import { render, staticRenderFns } from "./Opencart.vue?vue&type=template&id=0345a9da&scoped=true"
import script from "./Opencart.vue?vue&type=script&lang=js"
export * from "./Opencart.vue?vue&type=script&lang=js"
import style0 from "./Opencart.vue?vue&type=style&index=0&id=0345a9da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0345a9da",
  null
  
)

export default component.exports